import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private titleSubject = new BehaviorSubject<string>(''); 
  title$ = this.titleSubject.asObservable();

  setTitle(titleKey: string) {
    this.titleSubject.next(titleKey);
  }
}
